import '../../assets/css/style.css';
import '../../assets/css/all.min.css';
import HeaderComponent from "../../components/Header/Header.jsx";
import FooterComponent from "../../components/Footer/Footer.jsx";
import Loading from "../../components/Loading/Loading.jsx";
import { Link } from 'react-router-dom';

function BlogPage() {
  return <>
    <Loading></Loading>
    <HeaderComponent></HeaderComponent>

{/* section */}
    <section className="hero blog_hero">
      <div className="hero__wrapper blog_hero__wrapper">
        <div className="container">
          <div className="row">
            <div>
              <h1>Our blog.</h1>
            </div>
            <div>
              <ul>
                <li><Link href="/">Home</Link></li>
                <li><Link href="/Blog"><i className="fad fa-long-arrow-right" />Blog</Link></li>
              </ul>
              <div className="icon">
                <i className="fad fa-bullhorn" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

{/* section */}
    <section className="blog">
      <div className="blog__wrapper">
        <div className="container">
          <div className="blog__header">
            <div className="row">
              <div className="col-lg-3">
                <div className="category__dropdown dropdown-wrapper">
                  <div className="category__dropdown-info dropdown-info">
                    <h6>Category</h6>
                    <i className="fad fa-angle-double-down" />
                  </div>
                  <div className="category__dropdown-box dropdown-box">
                    <ul>
                      <li>Technology</li>
                      <li>Application</li>
                      <li>Updates</li>
                      <li>Promotions</li>
                      <li>Help articles</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="date__dropdown dropdown-wrapper">
                  <div className="date__dropdown-info dropdown-info">
                    <h6>Date</h6>
                    <i className="fad fa-angle-double-down" />
                  </div>
                  <div className="date__dropdown-box dropdown-box">
                    <ul>
                      <li>December 2020</li>
                      <li>November 2020</li>
                      <li>October 2020</li>
                      <li>September 2020</li>
                      <li>August 2020</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="search">
                  <input type="text" placeholder="Search" className="input-field" />
                  <i className="fad fa-search" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blog__content">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--1">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-1.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-8">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--2">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-2.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-8 left">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--3">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-3.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--4">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-4.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--5">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-5.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-8">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--6">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-6.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-8 left">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--7">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-7.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4">
                <a href="blog-single.html">
                  <div className="blog__single blog__single--8">
                    <div className="blog__single-image">
                      <img src={require('../../assets/images/blog-img-8.png')} alt="image" />
                    </div>
                    <div className="blog__single-info">
                      <h3>New features coming in 2020 to our app.</h3>
                      <h4>12 <i className="fad fa-comment" /><span>|</span>Dec 17, 2020</h4>
                      <p className="paragraph dark">Suisque metus tortor ultricies ac ligula neced
                        eleifend dales felise morbi nec tempor isvel ultricies lideula. </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <a href="#" className="button">
          <span>LOAD MORE <i className="fad fa-long-arrow-right" /></span>
        </a>
      </div>
    </section>

{/* section */}
{/* newsletter section */}
  <section className="newsletter">
      <div className="newsletter__wrapper">
        <div className="container">
          <div className="row align-items-lg-center">
            <div className="col-lg-6">
              <div className="newsletter__info">
                <h2 className="section-heading color-black">Subscribe to our newsletter.</h2>
                <form className="newsletter__info--field">
                  <input type="text" placeholder="Email address" className="input-field" />
                  <button className="button"><span>SUBSCRIBE <i className="fad fa-long-arrow-right" /></span></button>
                </form>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="newsletter__img">
                <img src={require('../../assets/images/newsletter-img.png')} alt="image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

{/* section footer */}
  <FooterComponent></FooterComponent>
  </>
}

export default BlogPage;